import has from 'lodash/has'

export function getCustomStylesById (app, id) {
  if (has(app, ['customFields', 'customStyles', id])) {
    return app.customFields.customStyles[id]
  } else {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/utils/appUtils.js